module.exports = __webpack_public_path__ + "static/media/woman-beside-pool.cce5ec89.jpg";